

<div class="container">
  <div class="description-section">
    <mtn-spinner [on]="isDataLoading || isExporting" [isPageSpinner]="false"></mtn-spinner>
    <p>Add details about the analysis for future reference. This information will be added to the exported PDF.</p>
    <mtn-text-area-field [form]="form" controlName="description" placeholder="Description" (keydown)="onKeyDown($event)" (input)="onInput($event)"></mtn-text-area-field>
    <div class="custom-character-count">{{ getCustomCharacterCount() }}/150</div>
    <!-- <div *ngIf="form.controls.description.errors?.maxLines" class="error-message">
      Maximum 4 lines allowed
    </div> -->
  </div>
  <!-- <div *ngIf="form.controls.description.errors?.maxlength" class="error-message">
      Maximum 150 characters allowed
    </div> -->
  <p class="store-limit-warning">Please <strong>limit your selection to 100 stores or fewer</strong> to avoid heavy server load and ensure successful export.</p>
</div>
